import React from 'react';
import HomeWidgets from './HomeWidgets';

const Home = () => <HomeWidgets spacing={3} />;

export default Home;
